import i18n from 'i18next';
import create, { UseStore } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import { environment } from '../../environments/environment';
import { getStoreName } from '../utils/functions';
import { UseLangStore } from './models';

const defaultBrowserLanguage = (() => {
  let language = (window.navigator.languages ? window.navigator.languages[0] : null) || window.navigator.language;

  if (language.indexOf('-') !== -1)
    language = language.split('-')[0];

  if (language.indexOf('_') !== -1)
    language = language.split('_')[0];

  return language;
})();

const defaultLanguage = ['pt-BR', 'es'].find(lang => lang.startsWith(defaultBrowserLanguage)) || 'pt-BR';

export function createLangStore(): UseStore<UseLangStore> {
  return create<UseLangStore>(
    devtools(
      persist((set) => ({
        lang: defaultLanguage,
        setLang(lang) {
          i18n.changeLanguage(lang).then(() => {
            set({ lang });
          });
        },
      }), {
        name: getStoreName('useLang'),
        version: environment.zustandStoreVersion,
        onRehydrateStorage: () => {
          return (state) => {
            state.setLang(state.lang);
          };
        },
      }), getStoreName('useLang'),
    ),
  );
}
